import { Get } from "../fetch";
import { urls } from "../constants";
export async function getVendorPublicConfigurations() {
  return Get(`${urls.subscriptions.billing.configurations.vendorPublicConfigurations.v1}`);
}